import React from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import SignatureCanvas from "react-signature-canvas";
import "../styles/style.css";

// Function to capitalize words
const capitalizarCadaPalabra = (texto) => {
  if (!texto) return "";
  return texto
    .split(" ")
    .map(
      (palabra) =>
        palabra.charAt(0).toUpperCase() + palabra.slice(1).toLowerCase()
    )
    .join(" ");
};

// Function to format time in AM/PM
const formatearHoraAMPM = (date) => {
  const horas = date.getHours();
  const minutos = date.getMinutes();
  const ampm = horas >= 12 ? "PM" : "AM";
  const horas12 = horas % 12 || 12; // Converts 0 to 12 for midnight
  const minutosFormateados = minutos < 10 ? `0${minutos}` : minutos;
  return `${horas12}:${minutosFormateados} ${ampm}`;
};

const ITEMS_POR_PAGINA = 10;
const RANGO_PAGINAS = 10;
const PASSWORD_PARA_BORRAR = "RXO2007"; // Password to delete records

class ListaMensajeria extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datosCargados: false,
      entregas: [],
      textoBusqueda: "",
      paginaActual: 1,
      filtroEstado: "todos", // ✅ NUEVO ESTADO para controlar el filtro
      nombreUsuario: localStorage.getItem("nombre") || "",
      tipoUsuario: localStorage.getItem("tipo") || "",
      modalVisible: false,
      entregaSeleccionada: null,
      nombreReceptor: "",
      fechaEntrega: "",
      horaEntrega: "",
      observaciones: "",
      firma: "",
      formEnvioVisible: false,
      vistaMovil: window.innerWidth < 768,
    };
    this.signatureRef = React.createRef();
    this.handleResize = this.handleResize.bind(this);
  }

  handleResize() {
    this.setState({ vistaMovil: window.innerWidth < 768 });
  }

  borrarRegistros = (id) => {
    Swal.fire({
      title: "Confirmación Requerida",
      text: "Por favor, ingrese la contraseña para eliminar este registro:",
      input: "password",
      inputPlaceholder: "Contraseña",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Verificar y Continuar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      inputValidator: (value) => {
        if (!value) {
          return "¡La contraseña es obligatoria!";
        }
        if (value !== PASSWORD_PARA_BORRAR) {
          return "¡Contraseña incorrecta!";
        }
        return null;
      },
      preConfirm: (password) => {
        return password;
      },
    }).then((passwordResult) => {
      if (passwordResult.isConfirmed) {
        Swal.fire({
          title: "¿Estás realmente seguro?",
          text: "No podrás revertir esto.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, borrar",
          cancelButtonText: "No, cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            fetch(
              // `http://localhost/mensajeriaRX/mensajeriaRX/mensajeria/src/baseDatos/mensajeria.php?borrar=${id}`
              `./mensajeria.php?borrar=${id}`
            )
              .then((respuesta) => respuesta.json())
              .then(() => {
                this.cargarDatosEntregas();
                Swal.fire(
                  "¡Borrado!",
                  "El registro ha sido borrado.",
                  "success"
                );
              })
              .catch((error) => {
                console.error("Error:", error);
                Swal.fire(
                  "Error",
                  "Hubo un problema al borrar el registro.",
                  "error"
                );
              });
          }
        });
      }
    });
  };

  // ✅ MÉTODO MODIFICADO para incluir el filtro en la llamada a la API
  cargarDatosEntregas() {
    const { filtroEstado } = this.state;
    // let url = "http://localhost/mensajeriaRX/mensajeriaRX/mensajeria/src/baseDatos/mensajeria.php?listarEntregas";
    let url = "./mensajeria.php?listarEntregas";

    if (filtroEstado !== "todos") {
      url += `&estado=${filtroEstado}`;
    }

    fetch(url)
      .then((respuesta) => respuesta.json())
      .then((datosRespuesta) => {
        if (Array.isArray(datosRespuesta)) {
          this.setState({ entregas: datosRespuesta, datosCargados: true });
        } else {
          this.setState({ entregas: [], datosCargados: true });
          console.error(
            "La respuesta de la API no es un array:",
            datosRespuesta
          );
        }
      })
      .catch((error) => {
        console.error("Error al cargar entregas:", error);
        this.setState({ datosCargados: true, entregas: [] });
      });
  }

  // ✅ NUEVO MÉTODO para manejar el cambio de filtro
  manejarCambioFiltro = (estado) => {
    this.setState({ filtroEstado: estado, paginaActual: 1 }, () => {
      this.cargarDatosEntregas();
    });
  };

  componentDidMount() {
    this.cargarDatosEntregas();
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  manejarCambioBusqueda = (evento) => {
    this.setState({
      textoBusqueda: evento.target.value,
      paginaActual: 1,
    });
  };

  limpiarBusqueda = () => {
    this.setState({
      textoBusqueda: "",
      paginaActual: 1,
    });
  };

  obtenerEntregasFiltradas() {
    const { entregas, textoBusqueda } = this.state;
    const textoBusquedaLower = textoBusqueda.toLowerCase();

    if (!textoBusqueda) {
      return entregas;
    }

    return entregas.filter(
      (entrega) =>
        entrega.nombrePaciente?.toLowerCase().includes(textoBusquedaLower) ||
        entrega.documentoPaciente?.toLowerCase().includes(textoBusquedaLower) ||
        entrega.nombreDoctorConsultorio
          ?.toLowerCase()
          .includes(textoBusquedaLower) ||
        entrega.tipoEntrega?.toLowerCase().includes(textoBusquedaLower) ||
        entrega.deliveryTime?.toLowerCase().includes(textoBusquedaLower) ||
        entrega.userName?.toLowerCase().includes(textoBusquedaLower)
    );
  }

  manejarCambioPagina = (pagina) => {
    this.setState({ paginaActual: pagina });
  };

  abrirModal = (entrega) => {
    const ahora = new Date();
    this.setState({
      modalVisible: true,
      entregaSeleccionada: entrega,
      nombreReceptor: "",
      fechaEntrega: ahora.toISOString().split("T")[0],
      horaEntrega: formatearHoraAMPM(ahora),
      observaciones: "",
      firma: "",
      formEnvioVisible: false,
    });
    document.body.classList.add("modal-open");
  };

  cerrarModal = () => {
    this.setState({
      modalVisible: false,
      entregaSeleccionada: null,
      nombreReceptor: "",
      fechaEntrega: "",
      horaEntrega: "",
      observaciones: "",
      firma: "",
      formEnvioVisible: false,
    });
    document.body.classList.remove("modal-open");
  };

  mostrarFormularioEntrega = () => {
    this.setState({ formEnvioVisible: true });
  };

  ocultarFormularioEntrega = () => {
    this.setState({ formEnvioVisible: false });
  };

  manejarCambioInput = (evento) => {
    this.setState({
      [evento.target.name]: evento.target.value,
    });
  };

  limpiarFirma = () => {
    this.signatureRef.current.clear();
    this.setState({ firma: "" });
  };

  registrarEntrega = (evento) => {
    evento.preventDefault();

    const { entregaSeleccionada, nombreReceptor, fechaEntrega, observaciones } =
      this.state;

    if (!nombreReceptor) {
      Swal.fire("Error", "El nombre del receptor es obligatorio", "error");
      return;
    }

    const firmaBase64 = this.signatureRef.current.isEmpty()
      ? ""
      : this.signatureRef.current.getCanvas().toDataURL("image/png");

    const ahora = new Date();
    const horaActual = formatearHoraAMPM(ahora);

    const datosEntrega = {
      id: entregaSeleccionada.id,
      nombreReceptor,
      fechaEntrega,
      horaEntrega: horaActual,
      observaciones,
      firma: firmaBase64,
    };

    fetch(
      // "http://localhost/mensajeriaRX/mensajeriaRX/mensajeria/src/baseDatos/mensajeria.php",
      "./mensajeria.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          accion: "registrarEntrega",
          datos: datosEntrega,
        }),
      }
    )
      .then((respuesta) => respuesta.json())
      .then((resultado) => {
        if (resultado.success) {
          Swal.fire("¡Éxito!", "Entrega registrada correctamente", "success");
          this.cargarDatosEntregas();
          this.cerrarModal();
        } else {
          Swal.fire(
            "Error",
            resultado.message || "Error al registrar la entrega",
            "error"
          );
        }
      })
      .catch((error) => {
        console.error("Error al registrar entrega:", error);
        Swal.fire("Error", "Hubo un problema al registrar la entrega", "error");
      });
  };

  renderizarTarjetaMovil = (entrega, index) => {
    const { paginaActual } = this.state;
    const indiceInicial = (paginaActual - 1) * ITEMS_POR_PAGINA;

    return (
      <div key={entrega.id} className="card mb-3 shadow-sm">
        <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
          <span className="fw-bold"># {indiceInicial + index + 1}</span>
          <div className="badge bg-light text-dark">
            {entrega.nombreReceptor ? (
              <span className="badge bg-success">ENTREGADO</span>
            ) : (
              <span className="badge bg-warning text-dark">PENDIENTE</span>
            )}
          </div>
        </div>
        <div className="card-body">
          <h5 className="card-title text-uppercase fw-bold">
            {capitalizarCadaPalabra(entrega.nombrePaciente)}
          </h5>
          <div className="mb-2">
            <small className="text-muted">Documento:</small>
            <div className="text-uppercase">{entrega.documentoPaciente}</div>
          </div>
          <div className="mb-2">
            <small className="text-muted">Doctor/Consultorio:</small>
            <div className="text-uppercase">
              {capitalizarCadaPalabra(entrega.nombreDoctorConsultorio)}
            </div>
          </div>
          <div className="mb-2">
            <small className="text-muted">Dirección:</small>
            <div className="text-uppercase">{entrega.direccion}</div>
          </div>
          <div className="mb-2">
            <small className="text-muted">Tipo de Entrega:</small>
            <div className="text-uppercase fw-bold">{entrega.tipoEntrega}</div>
          </div>
          <div className="mb-2">
            <small className="text-muted">Hora de Registro:</small>
            <div className="text-uppercase">{entrega.deliveryTime}</div>
          </div>
          <div className="mb-2">
            <small className="text-muted">Usuario que Registra:</small>
            <div className="text-uppercase">{entrega.userName}</div>
          </div>
        </div>
        <div className="card-footer bg-light d-flex justify-content-between">
          <button
            className="btn btn-primary btn-sm"
            onClick={() => this.abrirModal(entrega)}
          >
            <i className="fa-solid fa-eye me-1"></i> Ver
          </button>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => this.borrarRegistros(entrega.id)}
          >
            <i className="fa-solid fa-trash me-1"></i> Eliminar
          </button>
        </div>
      </div>
    );
  };

  renderizarFilaTablaDesktop = (entrega, index) => {
    const { paginaActual } = this.state;
    const indiceInicial = (paginaActual - 1) * ITEMS_POR_PAGINA;

    return (
      <tr key={entrega.id}>
        <td className="fw-bold">{indiceInicial + index + 1}</td>
        <td
          className="text-truncate text-uppercase"
          style={{ maxWidth: "200px" }}
        >
          {capitalizarCadaPalabra(entrega.nombrePaciente)}
        </td>
        <td className="text-uppercase" style={{ maxWidth: "200px" }}>
          {entrega.documentoPaciente}
        </td>
        <td className="text-uppercase" style={{ maxWidth: "200px" }}>
          {capitalizarCadaPalabra(entrega.nombreDoctorConsultorio)}
        </td>
        <td className="fw-bold text-uppercase">{entrega.direccion}</td>
        <td className="fw-bold text-uppercase">{entrega.tipoEntrega}</td>
        <td className="fw-bold">
          {entrega.nombreReceptor ? (
            <span className="badge bg-success">ENTREGADO</span>
          ) : (
            <span className="badge bg-warning text-dark">PENDIENTE</span>
          )}
        </td>
        <td>
          <div className="btn-group" role="group">
            <button
              className="btn btn-primary"
              onClick={() => this.abrirModal(entrega)}
            >
              <i className="fa-solid fa-eye"></i>
            </button>
            <button
              className="btn btn-danger"
              onClick={() => this.borrarRegistros(entrega.id)}
            >
              <i className="fa-solid fa-trash"></i>
            </button>
          </div>
        </td>
      </tr>
    );
  };

  render() {
    const {
      datosCargados,
      textoBusqueda,
      paginaActual,
      filtroEstado, // ✅ OBTENER FILTRO DEL ESTADO
      modalVisible,
      entregaSeleccionada,
      nombreReceptor,
      fechaEntrega,
      horaEntrega,
      observaciones,
      formEnvioVisible,
      vistaMovil,
    } = this.state;

    const entregasFiltradas = this.obtenerEntregasFiltradas();
    const indiceInicial = (paginaActual - 1) * ITEMS_POR_PAGINA;
    const entregasPaginaActual = entregasFiltradas.slice(
      indiceInicial,
      indiceInicial + ITEMS_POR_PAGINA
    );
    const totalPaginas = Math.ceil(entregasFiltradas.length / ITEMS_POR_PAGINA);
    const paginaInicio = Math.max(
      1,
      paginaActual - Math.floor(RANGO_PAGINAS / 2)
    );
    const paginaFin = Math.min(totalPaginas, paginaInicio + RANGO_PAGINAS - 1);

    if (!datosCargados) {
      return (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="spinner-border text-success" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      );
    }

    return (
      <div className="card poppins-regular">
        <div className="card-header bg-dark">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
            <Link className="btn btn-light" to={"/agregar-entrega"}>
              <i className="fas fa-user-plus"></i> Agregar Nueva Entrega
            </Link>

            <div className="position-relative w-100 w-md-50">
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por paciente, documento, doctor..."
                value={textoBusqueda}
                onChange={this.manejarCambioBusqueda}
              />
              {textoBusqueda && (
                <button
                  type="button"
                  className="btn btn-light position-absolute top-50 end-0 translate-middle-y me-2"
                  onClick={this.limpiarBusqueda}
                  style={{ border: "none", boxShadow: "none" }}
                >
                  <i className="fas fa-times text-danger"></i>
                </button>
              )}
            </div>
          </div>
          {/* ✅ NUEVOS BOTONES DE FILTRADO */}
          <div className="mt-3 d-flex justify-content-center">
            <div
              className="btn-group"
              role="group"
              aria-label="Filtro de estado"
            >
              <button
                type="button"
                className={`btn ${
                  filtroEstado === "todos"
                    ? "btn-primary"
                    : "btn-outline-primary"
                }`}
                onClick={() => this.manejarCambioFiltro("todos")}
              >
                Todos
              </button>
              <button
                type="button"
                className={`btn ${
                  filtroEstado === "pendiente"
                    ? "btn-warning text-dark"
                    : "btn-outline-warning"
                }`}
                onClick={() => this.manejarCambioFiltro("pendiente")}
              >
                Pendientes
              </button>
              <button
                type="button"
                className={`btn ${
                  filtroEstado === "entregado"
                    ? "btn-success"
                    : "btn-outline-success"
                }`}
                onClick={() => this.manejarCambioFiltro("entregado")}
              >
                Entregados
              </button>
            </div>
          </div>
        </div>
        <div className="card-body text-center text-white bg-success">
          <h2 className="fw-bold pb-2">REGISTRO DE ENTREGAS</h2>

          {vistaMovil ? (
            <div className="row">
              {entregasPaginaActual.length > 0 ? (
                entregasPaginaActual.map((entrega, index) => (
                  <div className="col-12" key={entrega.id}>
                    {this.renderizarTarjetaMovil(entrega, index)}
                  </div>
                ))
              ) : (
                <div className="alert alert-warning">
                  No se encontraron registros para el filtro o búsqueda actual.
                </div>
              )}
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>PACIENTE</th>
                    <th>DOCUMENTO</th>
                    <th>DOCTOR</th>
                    <th>DIRECCION</th>
                    <th>TIPO DE ENTREGA</th>
                    <th>ESTADO</th>
                    <th>ACCIONES</th>
                  </tr>
                </thead>
                <tbody className="align-middle">
                  {entregasPaginaActual.length > 0 ? (
                    entregasPaginaActual.map((entrega, index) =>
                      this.renderizarFilaTablaDesktop(entrega, index)
                    )
                  ) : (
                    <tr>
                      <td
                        colSpan="8"
                        className="text-center text-dark bg-light"
                      >
                        No se encontraron registros para el filtro o búsqueda
                        actual.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
        {entregasFiltradas.length > ITEMS_POR_PAGINA && (
          <div className="card-footer text-muted bg-dark">
            <nav aria-label="Navegación de páginas">
              <ul className="pagination flex-wrap justify-content-center">
                <li className="page-item">
                  <button
                    className={`page-link ${
                      paginaActual === 1 ? "text-success" : "text-success"
                    }`}
                    disabled={paginaActual === 1}
                    onClick={() => this.manejarCambioPagina(1)}
                  >
                    Primera
                  </button>
                </li>
                <li className="page-item">
                  <button
                    className={`page-link ${
                      paginaActual === 1 ? "text-success" : "text-success"
                    }`}
                    disabled={paginaActual === 1}
                    onClick={() => this.manejarCambioPagina(paginaActual - 1)}
                  >
                    Anterior
                  </button>
                </li>
                {Array.from(
                  { length: paginaFin - paginaInicio + 1 },
                  (_, i) => i + paginaInicio
                ).map((pagina) => (
                  <li
                    key={pagina}
                    className={`page-item ${
                      pagina === paginaActual ? "bg-success text-white" : ""
                    }`}
                  >
                    <button
                      className={`page-link ${
                        pagina === paginaActual ? "text-white" : "text-success"
                      }`}
                      style={{
                        backgroundColor:
                          pagina === paginaActual ? "#198754" : "",
                      }}
                      onClick={() => this.manejarCambioPagina(pagina)}
                    >
                      {pagina}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className={`page-link ${
                      paginaActual === totalPaginas
                        ? "text-success"
                        : "text-success"
                    }`}
                    disabled={paginaActual === totalPaginas}
                    onClick={() => this.manejarCambioPagina(paginaActual + 1)}
                  >
                    Siguiente
                  </button>
                </li>
                <li className="page-item">
                  <button
                    className={`page-link ${
                      paginaActual === totalPaginas
                        ? "text-success"
                        : "text-success"
                    }`}
                    disabled={paginaActual === totalPaginas}
                    onClick={() => this.manejarCambioPagina(totalPaginas)}
                  >
                    Última
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}

        {/* Modal to view delivery details */}
        {entregaSeleccionada && (
          <div
            className={`modal fade ${modalVisible ? "show" : ""}`}
            style={{
              display: modalVisible ? "block" : "none",
              backgroundColor: "rgba(0,0,0,0.5)",
            }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="modalTitle"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content bg-light">
                <div className="modal-header bg-dark d-flex">
                  <h5
                    className="modal-title fs-6 text-white col-8"
                    id="modalTitle"
                  >
                    Detalles de la Entrega: <br />
                    <span className="text-uppercase fw-bold fs-4">
                      {capitalizarCadaPalabra(
                        entregaSeleccionada.nombrePaciente
                      )}
                    </span>
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={this.cerrarModal}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body bg-success">
                  <div className="poppins-regular bg-success">
                    <h3 className="card-title text-uppercase text-center fw-bold text-white pb-1">
                      Información de la Entrega
                    </h3>
                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th className="text-uppercase">Paciente:</th>
                                <td className="text-uppercase">
                                  {capitalizarCadaPalabra(
                                    entregaSeleccionada.nombrePaciente
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th className="text-uppercase">Documento:</th>
                                <td className="text-uppercase">
                                  {entregaSeleccionada.documentoPaciente}
                                </td>
                              </tr>
                              <tr>
                                <th className="text-uppercase">
                                  Doctor/Consultorio:
                                </th>
                                <td className="text-uppercase">
                                  {capitalizarCadaPalabra(
                                    entregaSeleccionada.nombreDoctorConsultorio
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th className="text-uppercase">Dirección:</th>
                                <td className="text-uppercase">
                                  {entregaSeleccionada.direccion}
                                </td>
                              </tr>
                              <tr>
                                <th className="text-uppercase">
                                  Tipo de Entrega:
                                </th>
                                <td className="text-uppercase">
                                  {entregaSeleccionada.tipoEntrega}
                                </td>
                              </tr>
                              <tr>
                                <th className="text-uppercase">
                                  Hora de Registro:
                                </th>
                                <td className="text-uppercase">
                                  {entregaSeleccionada.deliveryTime}
                                </td>
                              </tr>
                              <tr>
                                <th className="text-uppercase">
                                  Usuario que Registra:
                                </th>
                                <td className="text-uppercase">
                                  {entregaSeleccionada.userName}
                                </td>
                              </tr>
                              {entregaSeleccionada.nombreReceptor && (
                                <>
                                  <tr>
                                    <th className="text-uppercase">
                                      Recibido por:
                                    </th>
                                    <td className="text-uppercase">
                                      {capitalizarCadaPalabra(
                                        entregaSeleccionada.nombreReceptor
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th className="text-uppercase">
                                      Fecha de Entrega:
                                    </th>
                                    <td className="text-uppercase">
                                      {entregaSeleccionada.fechaEntrega} -{" "}
                                      {entregaSeleccionada.horaEntrega}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th className="text-uppercase">
                                      Observaciones:
                                    </th>
                                    <td className="text-uppercase">
                                      {entregaSeleccionada.observaciones}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th className="text-uppercase">Firma:</th>
                                    <td>
                                      {entregaSeleccionada.firma && (
                                        <img
                                          src={entregaSeleccionada.firma}
                                          alt="Firma"
                                          style={{
                                            maxWidth: "100%",
                                            maxHeight: "100px",
                                            border: "1px solid #ccc",
                                          }}
                                        />
                                      )}
                                    </td>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>

                        {!entregaSeleccionada.nombreReceptor &&
                          !formEnvioVisible && (
                            <div className="text-center mt-4">
                              <button
                                className="btn btn-primary"
                                onClick={this.mostrarFormularioEntrega}
                              >
                                Registrar Entrega
                              </button>
                            </div>
                          )}

                        {formEnvioVisible && (
                          <form
                            onSubmit={this.registrarEntrega}
                            className="mt-4 border p-3 rounded bg-light"
                          >
                            <h4 className="text-center mb-3 text-uppercase fw-bold">
                              Registrar Entrega
                            </h4>
                            <div className="mb-3">
                              <label
                                htmlFor="nombreReceptor"
                                className="form-label"
                              >
                                Nombre de quien recibe:
                              </label>
                              <input
                                type="text"
                                className="form-control text-uppercase"
                                id="nombreReceptor"
                                name="nombreReceptor"
                                value={nombreReceptor}
                                onChange={this.manejarCambioInput}
                                required
                              />
                            </div>
                            <div className="row mb-3">
                              <div className="col-md-6">
                                <label
                                  htmlFor="fechaEntrega"
                                  className="form-label"
                                >
                                  Fecha de Entrega:
                                </label>
                                <input
                                  type="date"
                                  className="form-control"
                                  id="fechaEntrega"
                                  name="fechaEntrega"
                                  value={fechaEntrega}
                                  onChange={this.manejarCambioInput}
                                  required
                                  disabled
                                />
                              </div>
                              <div className="col-md-6">
                                <label
                                  htmlFor="horaEntrega"
                                  className="form-label"
                                >
                                  Hora de Entrega:
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="horaEntrega"
                                  name="horaEntrega"
                                  value={horaEntrega}
                                  onChange={this.manejarCambioInput}
                                  required
                                  disabled
                                />
                              </div>
                            </div>
                            <div className="mb-3">
                              <label
                                htmlFor="observaciones"
                                className="form-label"
                              >
                                Observaciones:
                              </label>
                              <textarea
                                className="form-control text-uppercase"
                                id="observaciones"
                                name="observaciones"
                                value={observaciones}
                                onChange={this.manejarCambioInput}
                                rows="3"
                              />
                            </div>
                            <div className="mb-3">
                              <label className="form-label">Firma:</label>
                              <SignatureCanvas
                                ref={this.signatureRef}
                                penColor="black"
                                canvasProps={{
                                  className: "form-control",
                                  style: {
                                    height: "150px",
                                    backgroundColor: "#fff",
                                    width: "100%",
                                    border: "1px solid #ced4da",
                                  },
                                }}
                              />
                              <button
                                type="button"
                                className="btn btn-secondary mt-2"
                                onClick={this.limpiarFirma}
                              >
                                Limpiar Firma
                              </button>
                            </div>
                            <div className="text-center mt-3">
                              <button
                                type="submit"
                                className="btn btn-success me-2"
                              >
                                Guardar Entrega
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={this.ocultarFormularioEntrega}
                              >
                                Cancelar
                              </button>
                            </div>
                          </form>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ListaMensajeria;
